import { useState } from 'react';
import { useCart } from '../../hooks/useCart';
import { Button } from '../ui/Button';

export function CheckoutForm() {
  const { items } = useCart();
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  async function handleCheckout() {
    setIsLoading(true);
    setError(null);

    try {
      const res = await fetch('/api/orders/checkout', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'include',
        body: JSON.stringify({
          items: items.map((item) => ({
            productId: item.productId,
            quantity: item.quantity,
          })),
        }),
      });

      const json = await res.json();

      if (!res.ok) {
        throw new Error(json.error?.message || 'Checkout failed');
      }

      // Redirect to Stripe-hosted checkout
      if (json.data.url) {
        window.location.href = json.data.url;
      }
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Checkout failed');
      setIsLoading(false);
    }
  }

  return (
    <div>
      {error && <p className="mb-4 text-sm text-red-400">{error}</p>}
      <Button
        onClick={handleCheckout}
        isLoading={isLoading}
        disabled={items.length === 0}
        size="lg"
        className="w-full"
        data-testid="checkout-button"
      >
        Proceed to Checkout
      </Button>
    </div>
  );
}
